/* Printies — Build a Box enhancement.
   Adds a working +/- quantity stepper to every row in the "Your Bundle" box,
   so you can add or remove one at a time without scrolling back to the product
   tile. Each button forwards the click to the Easy Bundle Builder's own
   per-product stepper, so the app's pricing/state stay the single source of
   truth (we never touch its internals). Re-binds after the app re-renders. */
(function () {
  "use strict";
  if (!/\/apps\/gbb\//.test(location.pathname)) return; // bundle proxy pages only

  var SEL = {
    footer: ".gbbBundleFooter",
    item: ".gbbProductItem",
    title: ".gbbProductTitle",
    add: ".gbbQuantityStepperAddButton",
    remove: ".gbbQuantityStepperRemoveButton"
  };

  function cardByTitle() {
    var map = {};
    document.querySelectorAll(SEL.item).forEach(function (it) {
      var t = it.querySelector(SEL.title);
      if (t) map[t.textContent.trim()] = it;
    });
    return map;
  }

  function step(title, dir) {
    var card = cardByTitle()[title];
    if (!card) return;
    var btn = card.querySelector(dir > 0 ? SEL.add : SEL.remove);
    if (btn) btn.click();
  }

  function titleForRow(qtyLeaf) {
    var node = qtyLeaf;
    for (var i = 0; i < 6 && node; i++) {
      node = node.parentElement;
      if (!node) break;
      var leaves = [].slice.call(node.querySelectorAll("div")).filter(function (n) {
        return !n.children.length && n.textContent.trim();
      });
      var cand = leaves.find(function (n) {
        var tx = n.textContent.trim();
        return !/^x\d+$/.test(tx) && !/^\$/.test(tx);
      });
      if (cand) return cand.textContent.trim();
    }
    return null;
  }

  function enhance() {
    var footer = document.querySelector(SEL.footer);
    if (!footer) return;
    [].slice.call(footer.querySelectorAll("div")).forEach(function (el) {
      if (el.children.length) return;
      var m = /^x(\d+)$/.exec(el.textContent.trim());
      if (!m) return;
      var cell = el.parentElement;
      if (!cell) return;
      el.style.display = "none";
      if (cell.querySelector(".pt-step")) {
        var n = cell.querySelector(".pt-step-num");
        if (n) n.textContent = m[1];
        return;
      }
      var title = titleForRow(el);
      if (!title) return;

      var wrap = document.createElement("div");
      wrap.className = "pt-step";
      var minus = document.createElement("button");
      minus.type = "button";
      minus.className = "pt-step-btn";
      minus.setAttribute("aria-label", "Remove one " + title);
      minus.textContent = "−";
      var num = document.createElement("span");
      num.className = "pt-step-num";
      num.textContent = m[1];
      var plus = document.createElement("button");
      plus.type = "button";
      plus.className = "pt-step-btn";
      plus.setAttribute("aria-label", "Add one " + title);
      plus.textContent = "+";

      minus.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation(); step(title, -1);
      });
      plus.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation(); step(title, 1);
      });
      wrap.appendChild(minus); wrap.appendChild(num); wrap.appendChild(plus);
      cell.appendChild(wrap);
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; try { enhance(); } catch (e) {} }, 80);
  }

  function start() {
    var footer = document.querySelector(SEL.footer);
    if (!footer) { setTimeout(start, 400); return; }
    enhance();
    var root = document.querySelector(".gbbBundleWrapper") ||
               document.querySelector(".gbbFullPageBundle") || document.body;
    new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, characterData: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

/* Printies — rotating mascot favicon + header logo (one random face per page load) */
(function () {
  var BASE = "https://cdn.shopify.com/s/files/1/0712/6374/8275/files/printies-fav-";
  var V = "?v=jun28-recut2";
  // All 20 frames: 5/10/15/20 recut by hand to give the P proper margin inside the badge.
  var favs = [];
  for (var i = 1; i <= 20; i++) { favs.push(BASE + ("0" + i).slice(-2) + ".png" + V); }
  var pick = favs[Math.floor(Math.random() * favs.length)];

  function setFavicon(href) {
    var sel = "link[rel~='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']";
    document.querySelectorAll(sel).forEach(function (l) { if (l.parentNode) l.parentNode.removeChild(l); });
    [["icon"], ["shortcut icon"], ["apple-touch-icon"]].forEach(function (r) {
      var l = document.createElement("link");
      l.rel = r[0]; l.type = "image/png"; l.href = href;
      document.head.appendChild(l);
    });
  }
  setFavicon(pick);

  function swapHeaderLogo() {
    var imgs = document.querySelectorAll(".header__heading-logo");
    imgs.forEach(function (img) {
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      img.src = pick;
      img.setAttribute("data-pt-mascot", "1");
    });
  }
  if (document.readyState !== "loading") swapHeaderLogo();
  else document.addEventListener("DOMContentLoaded", swapHeaderLogo);
})();
